import { render, staticRenderFns } from "./PostCopyModal.vue?vue&type=template&id=67ec61f0&"
import script from "./PostCopyModal.vue?vue&type=script&lang=ts&"
export * from "./PostCopyModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports